import React, { FunctionComponent } from 'react';

import './styles/_main.scss';

import AssetNameInput from '@components/asset/modal/tabs/edit/side_bar/assetNameInput';

import AttachmentListContainer from './attachmentListContainer';

const GenericFileSideBar: FunctionComponent<{}> = () => (
  <div className="edit-tab-sidebar one-third bf-scroll-element">
    <AssetNameInput />
    <AttachmentListContainer />
  </div>
);

export default GenericFileSideBar;
